import React, {useEffect} from 'react';

// generate random hexColor
// generate random number and floor it with << from float to int
// and convert it to base16 string with toString(16)...
const generateColor = () => {
    return '#' + (Math.random() * 0xFFFFFF<<0).toString(16);
}


// React.memo will prevent the other buttons for example from the CounterApp
// to change / fire this generateColor().
// SO THIS WILL ONLY GET RENDERED IF THE PROPS (of this component) ARE CHANGED!!!
const CounterView = (props) => {

    const {countValue, handleIncrement} = props;

    // useEffect Hook
    useEffect(() => {
        console.log("call fx");
    },  [countValue] //This is called only if countValue is CHANGED
    );

    return (
        <div>
            <h1 className="value">{countValue}</h1>
            <div style={{background: generateColor()}}> <h2>&nbsp;</h2> </div>
            <button onClick={handleIncrement(-1)}>Decrement</button>
            <button onClick={handleIncrement(1)}>Increment</button>
        </div>
        
    )

}

// You can just put the react memo here in the export:
export default React.memo(CounterView);



// // React.memo will prevent the other buttons for example from the CounterApp
// // to change / fire this generateColor().
// // SO THIS WILL ONLY GET RENDERED IF THE PROPS (of this component) ARE CHANGED!!!
// const CounterView = React.memo((props) => {

//     const {countValue, handleIncrement} = props;

//     // useEffect Hook
//     useEffect(() => {
//         console.log("call fx");
//     },  [countValue] //This is called only if countValue is CHANGED
//     );

//     return (
//         <div>
//             <h1 className="value">{countValue}</h1>
//             <div style={{background: generateColor()}}> <h2>&nbsp;</h2> </div>
//             <button onClick={handleIncrement(-1)}>Decrement</button>
//             <button onClick={handleIncrement(1)}>Increment</button>
//         </div>
        
//     )

// })


// export default CounterView;